import { ToastProps } from '@helix/toasts/build/src/types';
import * as Sentry from '@sentry/react';
import { v4 as uuidv4 } from 'uuid';

export const ToastAlertWithTimeOut = (
    addToast: (toast: ToastProps) => void,
    success: boolean,
    message: string,
    error?: Error,
    duration: number = 10000
): void => {
    if (success) {
        addToast({
            id: 'toast-success-id',
            dataLwtId: 'success-toast',
            type: 'success',
            text: message,
            dismissTime: duration,
        });
    } else {
        addToast({
            id: 'toast-warning-id',
            dataLwtId: 'warning-toast',
            type: 'warning',
            text: message,
            dismissTime: 2 * duration,
        });
    }

    if (error) {
        const uuid = uuidv4();
        Sentry.captureException(new Error(`${error.message}: ${uuid}`)); // we already captured fetch fails above
    }
};
